// `image.actor`: live's AI Actors portraits (G8-actor-generation).
// The AI Actors page builds these; its own badge is Prompt or Builder. An actor takes its
// references in its own form: it is its own pair.
import { ImageActorQuote, ImageActorRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { commonFields, sourcesOf } from "./shared";

export const jobType: JobTypeModule<"image.actor"> = {
  type: "image.actor",
  label: "AI Actor",
  source: "form",
  pair: "image.actor",
  fields: (draft) => ({ ...commonFields(draft), references: [...sourcesOf(draft), ...draft.references] }),
  request: ImageActorRequest,
  quote: ImageActorQuote,
};
